import { render } from "./BFaceTransferButton.vue?vue&type=template&id=c37f8f70"
import script from "./BFaceTransferButton.vue?vue&type=script&lang=js"
export * from "./BFaceTransferButton.vue?vue&type=script&lang=js"
script.render = render

export default script